module.exports = __webpack_public_path__ + "img/feature07.965eaf9.png";